import { render, staticRenderFns } from "./Json.vue?vue&type=template&id=b8e37b70&scoped=true&"
import script from "./Json.vue?vue&type=script&lang=js&"
export * from "./Json.vue?vue&type=script&lang=js&"
import style0 from "./Json.vue?vue&type=style&index=0&id=b8e37b70&scoped=true&lang=less&"
import style1 from "./Json.vue?vue&type=style&index=1&id=b8e37b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e37b70",
  null
  
)

export default component.exports